import script from "./ResearchGroupSharing.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResearchGroupSharing.vue?vue&type=script&lang=ts&setup=true"

import "./ResearchGroupSharing.vue?vue&type=style&index=0&id=37d1e39a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37d1e39a"]])

export default __exports__